(function() {
// Unified movement handler for both mouse and touch events
  function handleMovement(e: MouseEvent | Touch) {
    const eyes = document.querySelectorAll('.logo-eye') as NodeListOf<HTMLElement>
    if (eyes.length === 0) return

    eyes.forEach((eye) => {
      // Get eye element's position and dimensions
      const eyeRect = eye.getBoundingClientRect()
      const eyeCenterX = eyeRect.left + eyeRect.width / 2
      const eyeCenterY = eyeRect.top + eyeRect.height / 2

      // Calculate distance from pointer/touch to eye center
      const deltaX = e.clientX - eyeCenterX
      const deltaY = e.clientY - eyeCenterY

      // Calculate angle between pointer/touch and eye
      const angle = Math.atan2(deltaY, deltaX)

      // Maximum translation distance (1px)
      const maxDistance = 1

      // Calculate new position
      const translateX = Math.cos(angle) * maxDistance
      const translateY = Math.sin(angle) * maxDistance

      // Apply translation
      eye.style.transform = `translate(${translateX}px, ${translateY}px)`
    })
  }

  // Reset position when interaction ends
  function resetEyes() {
    const eyes = document.querySelectorAll('.logo-eye') as NodeListOf<HTMLElement>
    eyes.forEach((eye) => {
      eye.style.transform = 'translate(0, 0)'
    })
  }

  document.addEventListener('mousemove', handleMovement)
  document.addEventListener('touchmove', (e) => {
    // Use the first touch point
    handleMovement(e.touches[0])
  })
  document.addEventListener('mouseleave', resetEyes)
})()
